import { PropsWithChildren } from 'react'
import { cn } from '../utils'

export enum ParagraphType {
  Title,
  Subtitle,
  Text,
}

export function Paragraph({
  children,
  className,
  type = ParagraphType.Text,
  id,
}: PropsWithChildren<PropsWithClass<{ id?: string; type?: ParagraphType }>>) {
  return (
    <p
      className={cn(
        {
          'mb-10 text-4xl font-bold capitalize': type === ParagraphType.Title,
          'mb-10 text-3xl font-semibold capitalize': type === ParagraphType.Subtitle,
          'text-2xl font-normal': type === ParagraphType.Text,
        },
        className,
      )}
      id={id}
    >
      {children}
    </p>
  )
}
